import script from "./WalkthroughAdminPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalkthroughAdminPage.vue?vue&type=script&setup=true&lang=ts"

import "./WalkthroughAdminPage.vue?vue&type=style&index=0&id=66a39c3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66a39c3e"]])

export default __exports__